import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
  SelectProps,
} from '@chakra-ui/react';
import { KeyMapper, LabelMapper, ValueMapper } from '../mapperTypes';
import { InputHTMLAttributes, PropsWithChildren } from 'react';
import useTranslate from '~/common/utils/translate';
import { Field, FieldProps } from 'formik';
import { Option } from './Option';
import _ from 'lodash';

type SelectFieldProps<T, O extends string | number> = {
  defaultvalue?: boolean;
  fields: T[];
  labels: LabelMapper<T>;
  values: ValueMapper<T, O>;
  keys: KeyMapper<T>;
  label?: string;
  placeholder?: string;
  params?: string[];
  errorParams?: string[];
} & InputHTMLAttributes<HTMLSelectElement> &
  SelectProps;

export function SelectField<T, O extends string | number>({
  fields,
  defaultvalue,
  labels,
  values,
  label,
  placeholder,
  keys,
  params,
  errorParams,
  ...rest
}: PropsWithChildren<SelectFieldProps<T, O>>): JSX.Element {
  const translate = useTranslate();
  return (
    <Field as="select" {...rest}>
      {({ field, meta }: FieldProps) => (
        <FormControl isInvalid={!!meta.error}>
          {label ? (
            <FormLabel htmlFor={field.name}>
              {translate(label, params)}
            </FormLabel>
          ) : null}
          <Select
            borderColor="blackAlpha.600"
            {...field}
            {...rest}
            id={field.name}
          >
            {placeholder ? <Option value="-1">{placeholder}</Option> : null}
            {/* Wenn defaultvalue true ist wird hier eine Liste übergeben deren 
            erstes Element der default ist der Rest wird sortiert nach label */}
            {(defaultvalue
              ? [fields[0], ..._.orderBy(fields.slice(1), labels)]
              : _.orderBy(fields, labels)
            ).map((f) => (
              <option key={keys(f)} value={values(f)}>
                {translate(labels(f))}
              </option>
            ))}
          </Select>
          {meta.touched && meta.error ? (
            <FormErrorMessage>
              {translate(meta.error, errorParams)}
            </FormErrorMessage>
          ) : null}
        </FormControl>
      )}
    </Field>
  );
}
